import { Component, Inject } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { EmpDetails } from "@aptsi-types";
import { IdentityProvisioningService } from "../../identity-provisioning/identity-provisioning.service";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { SuccessDialogComponent } from "../../shared/dialogs/success-dialog/success-dialog.component";
import { startWith } from "rxjs/operators";
import { EnvironmentService } from "src/app/core/service/environment.service";

@Component({
  selector: "app-transfer-emp",
  templateUrl: "./transfer-emp.component.html",
  styleUrls: ["./transfer-emp.component.scss"],
})
export class TransferEmpComponent {
  form: FormGroup;
  empDetails: EmpDetails[] = [];

  verify: string;
  readonly organizationOptions = [
    "Acme corp 1",
    "Acme corp 2",
    "Acme corp 3",
    "None",
  ];
   organizationUnitOptions = [
    "Sales",
    "Marketing",
    "Engineering",
    "None",
  ];

  existingDigitalId: string;
  existingOrganization: string;
  existingOrganizationUnit: string;
  existingOrganizationId: string;


  constructor(
    private router: Router,
    private identityProvisioningService: IdentityProvisioningService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public environmentService: EnvironmentService 
  ) {
    this.existingDigitalId = this.route.snapshot.params.digitalId;
    this.existingOrganization = this.route.snapshot.params.organization;
    this.existingOrganizationUnit = this.route.snapshot.params.organizationUnit;
    this.existingOrganizationId = this.route.snapshot.params.organizationId;
  }

  async ngOnInit(): Promise<void> {
    this.form = new FormGroup({
      organization: new FormControl("None", [
        Validators.required,
        this.typeValidatorFactory(this.existingOrganization),
      ]),
      organizationUnit: new FormControl("None",[
        Validators.required,
        this.typeValidatorFactory(this.existingOrganizationUnit),
      ]),
    });

   
    this.form.get("organization")?.valueChanges.subscribe((selectedOrg) => {
      if (selectedOrg === this.existingOrganization) {
        this.organizationUnitOptions = this.organizationUnitOptions.filter(
          (unit) => unit !== this.existingOrganizationUnit
        );
      } else {
        // Reset organizationUnitOptions when changing organization
        this.organizationUnitOptions = ["Sales", "Marketing", "Engineering", "None"];
      }
    });
  

      
  }

  typeValidatorFactory(existingOption: string) {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const selectedType = control.value;
      if (selectedType === "None") {
        return { noneSelected: true };
      } 
      // else if (selectedType === existingOption) {
      //   return { alreadySelected: true };
      // }
      return null;
    };
  }

  async transfer() {
    const response = await this.identityProvisioningService
      .transferEmpDetail(
        this.existingDigitalId,
        this.form.value.organization,
        this.form.value.organizationUnit
      )
      .toPromise();
    this.openSuccessDialog();
  }

  back() {
    this.router.navigate(["digital-identity/auth-tools/identity-admin-panel"]);
  }

  openSuccessDialog(): void {
    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      width: "250px",
      data: {
        isMessage: true,
        isCreateUpdate: false,
        title: "Asset Transfered Successfully",
        subTitle:
          "The asset has been successfully transferred to the new position.",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.router.navigate([
        "digital-identity/auth-tools/identity-admin-panel",
      ]);
    });
  }
}
